<template>
  <el-dialog center width="600px" :title="dialogTitle" :visible.sync="dialogFormVisible" @close="resetFrom('editForm')">
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item label="标题" :label-width="formLabelWidth" prop="name">
        <el-input v-model="editForm.name" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="宽度" :label-width="formLabelWidth" prop="width">
        <el-input-number v-model="editForm.width" :min="1" :max="99999" autocomplete="off"></el-input-number>
      </el-form-item>

      <el-form-item label="高度" :label-width="formLabelWidth" prop="height">
        <el-input-number v-model="editForm.height" :min="1" :max="99999" autocomplete="off"></el-input-number>
      </el-form-item>

     <el-form-item label="广告类型" :label-width="formLabelWidth" prop="type">
        <el-select v-model="editForm.type" placeholder="请选择">
          <el-option
            v-for="item in globalStatus"
                  :key="item.type"
                  :label="item.name"
                  :value="item.type">
          </el-option>
        </el-select>
      </el-form-item>

    </el-form>    

    <div slot="footer" class="dialog-footer">
      <el-button @click="resetFrom('editForm');dialogFormVisible = false;">取 消</el-button>
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { formData, formRules} from '../form.js'
import { positionAdd, positionEdit } from "@/api/bannerApi.js"
export default {
  name: 'editForm',
  data() {
    return {
      positionId: '',
      dialogTitle: '',
      dialogFormVisible: false,
      editForm: {...formData},
      editRules: formRules,
      formLabelWidth: "120px",
      globalStatus : [{
          type : 1,
          name : '图片'
        },
        {
          type : 2,
          name : '其他'
        }
      ]
    };
  },
  inject: ['reload'],
  computed: {

  },  
  props: [
    
  ],  

  methods: {
    resetFrom(){
      this.editForm = {}
    }, 
    submitEdit() {
      try {
        this.$refs.editForm.validate(async valid => {
        if(!valid) return this.$message.error("格式不对哦，检查一下呗!")
        
        if(this.positionId != ''){
          await positionEdit(this.positionId, {...this.editForm}).then(res => {
            if(res.code === 200){
              this.$message.success("编辑成功!")
            }
            else{
              this.$message.success("编辑失败!")
              return;
            }
          });
        }
        else{
          await positionAdd({...this.editForm}).then(res => {
            if(res.code === 200){
              this.$message.success("新增成功!")
            }
            else{
              this.$message.success("新增失败!")
              return;
            }
          });
        }
        this.dialogFormVisible = false
        this.editForm = {}
        // 重新获取数据
        this.reload()
     
      }); 
     } catch (e) {
       window.console.log(e)
     }
    }
  }
};
</script>

<style></style>
